import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ProductsSection from '../components/ProductsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import InstagramSection from '../components/InstagramSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="homepage">
      <Header />
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <TestimonialsSection />
      <InstagramSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
